<script setup lang="ts">
import { computed } from 'vue'
import {
  NConfigProvider,
  NLoadingBarProvider,
  NDialogProvider,
  NNotificationProvider,
  NMessageProvider,
  NModalProvider,
  darkTheme,
} from 'naive-ui'
import { RouterView } from 'vue-router'

import { useThemeStore } from '@/stores/theme'
import { useLocaleStore } from '@/stores/locale'
import { lightOverrides, darkOverrides } from '@/theme/overrides'

const theme = useThemeStore()
const locale = useLocaleStore()

const themeRef = computed(() => (theme.isDark ? darkTheme : null))
const overrides = computed(() => (theme.isDark ? darkOverrides : lightOverrides))
</script>

<template>
  <NConfigProvider
    :theme="themeRef"
    :theme-overrides="overrides"
    :locale="locale.naiveLocale"
    :date-locale="locale.naiveDateLocale"
    inline-theme-disabled
  >
    <NLoadingBarProvider>
      <NDialogProvider>
        <NNotificationProvider>
          <NMessageProvider>
            <NModalProvider>
              <RouterView />
            </NModalProvider>
          </NMessageProvider>
        </NNotificationProvider>
      </NDialogProvider>
    </NLoadingBarProvider>
  </NConfigProvider>
</template>

<style>
html,
body,
#app {
  height: 100%;
  margin: 0;
}
</style>
